import React from 'react'
import { SharedElement } from '@taito/react-sheltr'
import useStyles from './styles'
import classnames from 'clsx'

export const Thumb = ({ image, ...props }) => {
  const classes = useStyles()
  return <img className={classes.thumbImg} src={image.fullSizeUrl} {...props} />
}

export const FullImage = ({ image, closeImage, ...props }) => {
  const classes = useStyles()

  return (
    <div className={classes.fullImage} onClick={closeImage}>
      <SharedElement
        sharedId={image.original_image_name}
        startOnUnmount
        completeOnUnmount
      >
        {({ isTransitioning, ...sheltrProps }) => (
          <img
            className={classes.fullImageImg}
            src={image.fullSizeUrl}
            {...sheltrProps}
          />
        )}
      </SharedElement>
    </div>
  )
}

export const HeaderImage = ({ image, className, ...props }) => {
  const classes = useStyles()
  if (image === undefined) {
    image = {
      square_full_url:
        '//res.cloudinary.com/bidr/image/upload/fl_lossy,f_auto,d_eg_placeholder_xhn1xm.png//56394/eg_placeholder_xhn1xm'
    }
  }
  return (
    <img
      className={classnames(classes.headerImage, className)}
      src={image.square_full_url}
      {...props}
      alt="image"
    />
  )
}

export default Thumb



// WEBPACK FOOTER //
// ./src/components/ItemDetails/Image.jsx